<!-- src/views/customers/_form.vue -->
 <template>
  <div class="row g-3 mb-2">
    <!-- Customer Type -->
    <div class="col-md-4">
      <label class="form-label">{{ $t('page.customers.inputs.type') }}</label>
      <select v-model="formLocal.type" class="form-select" :class="{ 'is-invalid': errors.type }">
        <option value="PF">{{ $t('page.customers.types.pf') }}</option>
        <option value="PJ">{{ $t('page.customers.types.pj') }}</option>
      </select>
      <div v-if="errors.type" class="invalid-feedback">{{ errors.type[0] }}</div>
    </div>
  </div>

  <div class="row g-3">
    <!-- PF Fields -->
    <template v-if="formLocal.type === 'PF'">
      <div class="col-md-3">
        <label class="form-label">{{ $t('page.customers.inputs.first_name') }}</label>
        <input v-model="formLocal.first_name" type="text" class="form-control"
          :class="{ 'is-invalid': errors.first_name }"
          :placeholder="$t('page.customers.inputs.first_namePlaceholder')" />
        <div v-if="errors.first_name" class="invalid-feedback">{{ errors.first_name[0] }}</div>
      </div>

      <div class="col-md-6">
        <label class="form-label">{{ $t('page.customers.inputs.last_name') }}</label>
        <input v-model="formLocal.last_name" type="text" class="form-control"
          :class="{ 'is-invalid': errors.last_name }" :placeholder="$t('page.customers.inputs.last_namePlaceholder')" />
        <div v-if="errors.last_name" class="invalid-feedback">{{ errors.last_name[0] }}</div>
      </div>

      <div class="col-md-3">
        <label class="form-label">{{ $t('page.customers.inputs.birthday') }}</label>
        <input v-model="formLocal.birthday" type="date" class="form-control"
          :class="{ 'is-invalid': errors.birthday }" />
        <div v-if="errors.birthday" class="invalid-feedback">{{ errors.birthday[0] }}</div>
      </div>

      <div class="col-md-3">
        <label class="form-label">{{ $t('page.customers.inputs.cpf') }}</label>
        <input v-model="formLocal.cpf" type="text" class="form-control" :class="{ 'is-invalid': errors.cpf }"
          :placeholder="$t('page.customers.inputs.cpfPlaceholder')" />
        <div v-if="errors.cpf" class="invalid-feedback">{{ errors.cpf[0] }}</div>
      </div>
    </template>

    <!-- PJ Fields -->
    <template v-else>
      <div class="col-md-4">
        <label class="form-label">{{ $t('page.customers.inputs.company_name') }}</label>
        <input v-model="formLocal.company_name" type="text" class="form-control"
          :class="{ 'is-invalid': errors.company_name }"
          :placeholder="$t('page.customers.inputs.company_namePlaceholder')" />
        <div v-if="errors.company_name" class="invalid-feedback">{{ errors.company_name[0] }}</div>
      </div>

      <div class="col-md-4">
        <label class="form-label">{{ $t('page.customers.inputs.trade_name') }}</label>
        <input v-model="formLocal.trade_name" type="text" class="form-control"
          :class="{ 'is-invalid': errors.trade_name }"
          :placeholder="$t('page.customers.inputs.trade_namePlaceholder')" />
        <div v-if="errors.trade_name" class="invalid-feedback">{{ errors.trade_name[0] }}</div>
      </div>

      <div class="col-md-4">
        <label class="form-label">{{ $t('page.customers.inputs.cnpj') }}</label>
        <input v-model="formLocal.cnpj" type="text" class="form-control" :class="{ 'is-invalid': errors.cnpj }"
          :placeholder="$t('page.customers.inputs.cnpjPlaceholder')" />
        <div v-if="errors.cnpj" class="invalid-feedback">{{ errors.cnpj[0] }}</div>
      </div>

      <div class="col-md-3">
        <label class="form-label">{{ $t('page.customers.inputs.responsible') }}</label>
        <input v-model="formLocal.responsible" type="text" class="form-control"
          :class="{ 'is-invalid': errors.responsible }"
          :placeholder="$t('page.customers.inputs.responsiblePlaceholder')" />
        <div v-if="errors.responsible" class="invalid-feedback">{{ errors.responsible[0] }}</div>
      </div>
    </template>

    <!-- Contact Info -->
    <div class="col-md-4">
      <label class="form-label">{{ $t('page.customers.inputs.email') }}</label>
      <input v-model="formLocal.email" type="email" class="form-control" :class="{ 'is-invalid': errors.email }"
        :placeholder="$t('page.customers.inputs.emailPlaceholder')" />
      <div v-if="errors.email" class="invalid-feedback">{{ errors.email[0] }}</div>
    </div>

    <div class="col-md-3">
      <label class="form-label">{{ $t('page.customers.inputs.nationality') }}</label>
      <input v-model="formLocal.nationality" type="text" class="form-control"
        :class="{ 'is-invalid': errors.nationality }"
        :placeholder="$t('page.customers.inputs.nationalityPlaceholder')" />
      <div v-if="errors.nationality" class="invalid-feedback">{{ errors.nationality[0] }}</div>
    </div>

    <div class="col-md-2">
      <label class="form-label">{{ $t('page.customers.inputs.gender_id') }}</label>
      <select v-model="formLocal.gender_id" class="form-select" :class="{ 'is-invalid': errors.gender_id }">
        <option value="1">{{ $t('page.customers.genders.male') }}</option>
        <option value="2">{{ $t('page.customers.genders.female') }}</option>
        <option value="3">{{ $t('page.customers.genders.other') }}</option>
      </select>
      <div v-if="errors.gender_id" class="invalid-feedback">{{ errors.gender_id[0] }}</div>
    </div>

    <!-- Phones -->
    <div class="col-12">
      <label class="form-label">{{ $t('page.customers.inputs.phones') }} </label>
      <button type="button" class="btn btn-outline-primary btn-sm" @click="addPhone">
        <i class="fa fa-plus"></i> {{ $t('common.add') }}
      </button>
      <div v-for="(phone, index) in formLocal.phones" :key="index"
        class="d-flex align-items-center border rounded g-2 mb-2 p-3">
        <input v-model="phone.phone" type="text" class="form-control me-2" placeholder="Enter phone">
        <select v-model="phone.type" class="form-select me-2">
          <option value="mobile">Mobile</option>
          <option value="home">Home</option>
          <option value="work">Work</option>
        </select>
        <button type="button" class="btn btn-outline-danger btn-sm" @click="removePhone(index)">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>

    <!-- Addresses -->
    <div class="col-12">
      <label class="form-label">{{ $t('page.customers.inputs.addresses') }}</label>
      <button type="button" class="btn btn-outline-primary btn-sm" @click="addAddress">
        <i class="fa fa-plus"></i> {{ $t('common.add') }}
      </button>
      <div v-for="(address, index) in formLocal.addresses" :key="index"
        class="d-flex align-items-center border rounded g-2 mb-2 p-3">
        <input v-model="address.street" type="text" class="form-control" placeholder="Street">
        <input v-model="address.number" type="text" class="form-control" placeholder="Number">
        <input v-model="address.zip" type="text" class="form-control" placeholder="ZIP">
        <input v-model="address.state" type="text" class="form-control" placeholder="State">
        <input v-model="address.city" type="text" class="form-control" placeholder="City">
        <button type="button" class="btn btn-outline-danger btn-sm" @click="removeAddress(index)">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  form: { type: Object, required: true },
  errors: { type: Object, default: () => ({}) }
});
const emit = defineEmits(['update:form']);

const formLocal = ref({
  ...props.form,
  type: props.form.type || 'PF',
  phones: props.form.phones || [],
  addresses: props.form.addresses || []
});

const addPhone = () => formLocal.value.phones.push({ phone: '', type: 'mobile' });
const removePhone = (index) => formLocal.value.phones.splice(index, 1);

const addAddress = () => formLocal.value.addresses.push({ street: '', number: '', city: '', state: '', zip: '' });
const removeAddress = (index) => formLocal.value.addresses.splice(index, 1);

watch(formLocal, (val) => emit('update:form', val), { deep: true });
</script>

<style scoped></style>
